// extracted by mini-css-extract-plugin
export default {"content-wrapper":"index-module__content-wrapper___p5a4Q","contentWrapper":"index-module__content-wrapper___p5a4Q"};